/* This is generated code, don't alter */
var IfcTransportElementTypeEnum;
(function (IfcTransportElementTypeEnum) {
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["ELEVATOR"] = 0] = "ELEVATOR";
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["ESCALATOR"] = 1] = "ESCALATOR";
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["MOVINGWALKWAY"] = 2] = "MOVINGWALKWAY";
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["CRANEWAY"] = 3] = "CRANEWAY";
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["LIFTINGGEAR"] = 4] = "LIFTINGGEAR";
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcTransportElementTypeEnum[IfcTransportElementTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcTransportElementTypeEnum || (IfcTransportElementTypeEnum = {}));
const IfcTransportElementTypeEnumCount = 7;
export { IfcTransportElementTypeEnum, IfcTransportElementTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcTransportElementTypeEnum = new Int32Array([184]);
let prefixSumAddressIfcTransportElementTypeEnum = new Uint32Array([0, 15, 28, 40, 53, 63, 74, 84]);
let slotMapIfcTransportElementTypeEnum = new Int32Array([2, 5, 6, 4, 0, 1, 3]);
let encodedDataIfcTransportElementTypeEnum = (new TextEncoder()).encode(".MOVINGWALKWAY..USERDEFINED..NOTDEFINED..LIFTINGGEAR..ELEVATOR..ESCALATOR..CRANEWAY.");
let IfcTransportElementTypeEnumSearch = new MinimalPerfectHash(gMapIfcTransportElementTypeEnum, prefixSumAddressIfcTransportElementTypeEnum, slotMapIfcTransportElementTypeEnum, encodedDataIfcTransportElementTypeEnum);
export { IfcTransportElementTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcTransportElementTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcTransportElementTypeEnumSearch, input, cursor, endCursor);
}
